import React from 'react'
import {LogoutPage} from '../login/LogoutPage'
import {SiteUrls} from '../SiteUrls'
import {useHanmiManagerAppContext} from './context/HanmiManagerAppContext'

interface IAdminLogoutPageProps {}

export const HanmiManagerLogoutPage: React.FC<IAdminLogoutPageProps> = props => {
  const { logout } = useHanmiManagerAppContext()
  return <LogoutPage logout={logout} urlAfterLogout={SiteUrls.HanmiManager.Login} />
}
